DOMReady( function(){

  if( document.querySelector('.live-in-progress'))
  {
    setInterval(refreshlive, 120000);//2 minutes 
  }

  if(document.querySelector('#anchor_topcontent'))
  {
    document.querySelector('#anchor_topcontent').addEventListener('click',function(){
      window.scrollTo(document.body.clientHeigh, document.getElementById('content-live').offsetTop);
    });
  }

  async function refreshlive(){

      let pagedatas = document.body.dataset.pagedatas? JSON.parse( document.body.dataset.pagedatas ) : {};
      console.log('PAGEDATA UPDATED_AT',pagedatas.updated_at);
      return new Promise((resolve, reject) => {

        return fetch( '/refresh-live', {
          cache: "no-store",
          method: "POST",
          credentials:"omit",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            contentobject_id: pagedatas.contentobjectid,
            updated_at:pagedatas.updated_at
          }),
        } ).then( (response) => {
          return response.json();
        }).then( (dataresponse) => {
          if(dataresponse.success){
            document.getElementById('content-live').innerHTML = dataresponse.html;
            pagedatas.updated_at = dataresponse.new_updated_at;
            if( typeof dataLayer !== undefined ) {
              dataLayer.push({event:"pageview-dynamic"})
            }
            if( typeof _wsq !== undefined ) {
              _wsq.push(['_wysistat']);
            }
          }
        }).catch( (error) => {
          reject( 'Erreur' );
        });
      });
  }
});
